module.exports = __webpack_public_path__ + "img/moniter-01@3x.3a93b754.png";